
import Vue from 'vue'

const actions = {

    async List() {

        try {
            const result = await Vue.prototype.$spTechApi.get("comum/subsegmento/list-subsegmentos",
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                let listSubSegmentos = result.data.result;

                return listSubSegmentos;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Erro ao carregar sub-segmentos: [${ex}]`
            };
        }
    },
}

export default {
    namespaced: true,
    actions
}
